import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import { NON_BILLABLE_ACCOUNTS } from "static/account";
import { useSelector } from "react-redux";

const NonBillableToggle = ({
  account,
  nonBillable,
  onChange,
  tooltipTitle = "Enable to upload as a non-billable report.",
}) => {
  const { currentUser } = useSelector((state) => state.auth);

  const shouldShowToggle =
    currentUser?.accounts.some((userAccount) =>
      NON_BILLABLE_ACCOUNTS.includes(userAccount)
    ) && NON_BILLABLE_ACCOUNTS.includes(account);

  if (!shouldShowToggle) return null;

  return (
    <FormControlLabel
      labelPlacement="start"
      className="toggle-label"
      label={
        <div className="d-flex align-items-end">
          Non-Billable Report
          <Tooltip title={tooltipTitle}>
            <InfoIcon fontSize="small" className="ml-1" color="disabled" />
          </Tooltip>
        </div>
      }
      style={{ marginLeft: 0, marginRight: "2px" }}
      control={
        <Switch
          name="nonBillable"
          checked={nonBillable || false}
          onChange={onChange}
        />
      }
    />
  );
};

export default NonBillableToggle;
